export const baseRules1 = {
  title: [{ required: true, message: '请输入反馈主题', tirgger: 'blur' }],
  feedbackContent: [{ required: true, message: '请输入反馈内容', tirgger: 'blur' }],
};
export const baseRules2 = {
  processPlan: [{ required: true, message: '请输入处理方案', tirgger: 'blur' }],
  processPersonNo: [{ required: true, message: '请输入处理人', tirgger: 'blur' }],
};
